import { SignatureLine } from "@sw-sw/lib-certification";
import { FormSchema, SchemaFieldsWithContextUI } from "@sw-sw/lib-form";
import { UIControlType } from "@sw-sw/lib-form-control-types";
import { get, omit } from "lodash";
import React, { useContext } from "react";
import { SignatureEditorContext } from "../../../../contexts/SignatureEditorContext";
import FormModal from "../../../Shared/form/modal/FormModal";
import { SignatureEditorFormProps } from "./SignatureEditorForm";

const lineSchema: FormSchema = {
  label: {
    label: "Label",
    controlType: UIControlType.text,
    validation: {
      required: false,
    },
  },

  roleFieldLabel: {
    label: "Role Field Label",
    controlType: UIControlType.text,
    validation: {
      required: true,
    },
  },

  userFieldLabel: {
    label: "User Field Label",
    controlType: UIControlType.text,
    validation: {
      required: true,
    },
  },
};

type LineFormData = Omit<SignatureLine, "id" | "type">;

const LineForm: React.FC<SignatureEditorFormProps> = ({
  value,
  onSubmit: onSubmitProp,
}) => {
  const signatureEditorContext = useContext(SignatureEditorContext);

  if (!signatureEditorContext.formState) {
    console.trace(signatureEditorContext);

    throw new Error("signatureEditorContext.formState must be defined");
  }

  const initialFormData = omit(
    get(
      value.lines[signatureEditorContext.formState.groupType],
      signatureEditorContext.formState.resourceIndex,
      {
        label: "",
        roleFieldLabel: "Position",
        userFieldLabel: "Full Name",
      },
    ),
    ["id", "type"],
  );

  const onSubmit = async (formData: LineFormData) => {
    const data: typeof value = JSON.parse(JSON.stringify(value));

    if (signatureEditorContext.formState) {
      if (
        !value["lines"][signatureEditorContext.formState.groupType][
          signatureEditorContext.formState.resourceIndex
        ]
      ) {
        data["lines"][signatureEditorContext.formState.groupType].push({
          label: formData.label,
          userFieldLabel: formData.userFieldLabel,
          roleFieldLabel: formData.roleFieldLabel,
          type: signatureEditorContext.formState.groupType,
        });
      } else {
        data["lines"][signatureEditorContext.formState.groupType][
          signatureEditorContext.formState.resourceIndex
        ].label = formData["label"];

        data["lines"][signatureEditorContext.formState.groupType][
          signatureEditorContext.formState.resourceIndex
        ].userFieldLabel = formData["userFieldLabel"];

        data["lines"][signatureEditorContext.formState.groupType][
          signatureEditorContext.formState.resourceIndex
        ].roleFieldLabel = formData["roleFieldLabel"];
      }
    }

    onSubmitProp({ ...data });
    signatureEditorContext.setModal();
  };

  return (
    <FormModal
      onCancel={() => signatureEditorContext.setModal()}
      modalProps={{
        title: `${signatureEditorContext.formState.formType} Signature Line`,
      }}
      onSubmit={onSubmit}
    >
      <SchemaFieldsWithContextUI
        schema={lineSchema}
        initialFormData={initialFormData}
      />
    </FormModal>
  );
};

export default LineForm;
